// Validare usoara pentru telefon cu prefix; validarea completa (pe tara) o face api.vikart.ro
import {
    COUNTRIES,
    DEFAULT_COUNTRY,
    findCountry,
    findCountryByPrefix,
} from '../commons/countries';

// Trimis la API ca sa activeze validarea pe prefix (admin.users.update)
export const PHONE_FORMAT_PREFIXED = 'prefixed';

export interface PhoneValue {
    prefix: string;
    phone: string;
    phoneCountry: string;
}

// Prefixele ordonate descrescator dupa lungime, ca "+373" sa fie gasit inaintea lui "+37"
const PREFIXES: string[] = COUNTRIES.map((c) => c.prefix)
    .filter((prefix, index, all) => all.indexOf(prefix) === index)
    .sort((a, b) => b.length - a.length);

export class PhoneValidation {
    static digits(value: any): string {
        return value == undefined
            ? ''
            : String(value).replace(/\D/g, '');
    }

    static defaultValue(): PhoneValue {
        const country = findCountry(DEFAULT_COUNTRY);

        return {
            prefix: country ? country.prefix : '+40',
            phone: '',
            phoneCountry: DEFAULT_COUNTRY,
        };
    }

    // "+40 753..." / "0040753..." -> { prefix: '+40', phone: '753...', phoneCountry: 'RO' }
    static detectPrefix(raw: string): PhoneValue | undefined {
        const value = String(raw || '').trim();

        if (value.charAt(0) !== '+' && value.indexOf('00') !== 0) {
            return undefined;
        }

        const digits = this.digits(value).replace(/^00/, '');
        const prefix = PREFIXES.find((p) => digits.indexOf(p.slice(1)) === 0);
        const country = prefix ? findCountryByPrefix(prefix) : undefined;

        if (!prefix || !country) {
            return undefined;
        }

        return {
            prefix,
            phone: digits.slice(prefix.length - 1),
            phoneCountry: country.iso2,
        };
    }

    // Conturile vechi au doar `phone` (07..., +407..., 00407...) - le aducem in format cu prefix
    static fromUser(user: any): PhoneValue {
        if (!user) {
            return this.defaultValue();
        }

        if (user.prefix) {
            const country =
                findCountry(user.phoneCountry) ||
                findCountryByPrefix(user.prefix);

            return {
                prefix: user.prefix,
                phone: user.phone || '',
                phoneCountry: country ? country.iso2 : '',
            };
        }

        const detected = this.detectPrefix(user.phone);

        if (detected) {
            return detected;
        }

        return {
            ...this.defaultValue(),
            phone: this.digits(user.phone).replace(/^0/, ''),
        };
    }

    // Intoarce mesajul de eroare sau undefined daca e valid
    static validate(value: PhoneValue): string | undefined {
        if (!value.prefix || !findCountryByPrefix(value.prefix)) {
            return 'Te rugam sa selectezi prefixul tarii';
        }

        const phone = this.digits(value.phone).replace(/^0/, '');

        if (!phone) {
            return 'Te rugam sa introduci numarul de telefon';
        }

        if (phone.length < 4 || phone.length > 14) {
            return 'Numarul de telefon nu este valid';
        }

        return undefined;
    }

    // Pentru afisare: "+40 753 018 255", "+44 791 112 3456"; conturile vechi (fara prefix)
    // raman cum sunt salvate
    static format(user: any): string {
        if (!user || !user.phone) {
            return '';
        }

        if (!user.prefix) {
            return user.phone;
        }

        const groups = String(user.phone).match(/\d{1,3}/g) || [];

        // O cifra ramasa singura la final se lipeste de grupa dinainte ("346 0" -> "3460")
        if (groups.length > 1 && groups[groups.length - 1].length === 1) {
            const tail = groups.pop() as string;
            groups[groups.length - 1] += tail;
        }

        return user.prefix + ' ' + groups.join(' ');
    }

    // Payload-ul pentru API; telefonul pleaca doar cu cifre
    static toPayload(value: PhoneValue) {
        return {
            prefix: value.prefix,
            phone: this.digits(value.phone),
            phoneCountry: value.phoneCountry,
            phoneFormat: PHONE_FORMAT_PREFIXED,
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/phone-validation.ts